import api from '@/api';
import { SpedFileConsult, SpedFileDownloadRequest } from './sped-files.types';

const path = (id: number) => `/sped/v1/sped/sped-document/${id}/file`;

export default {
  async solicitation(spedDocumentId: number) {
    const result = (await api.post(
      `${path(spedDocumentId)}/solicitation`,
      {},
    )) as unknown;
    return result as Blob;
  },

  async download({ spedDocumentId, ...params }: SpedFileDownloadRequest) {
    const result = (await api.getReport(
      `${path(spedDocumentId)}/download`,
      params,
    )) as unknown;
    return result as BlobPart;
  },

  async consult(spedDocumentId: number) {
    const result = (await api.get(
      `${path(spedDocumentId)}/consult`,
      {},
    )) as unknown;
    return result as SpedFileConsult;
  },
};
